module.exports = __webpack_public_path__ + "img/metro_bluemarker.03c5f10c.png";